module.exports = __webpack_public_path__ + "images/smartorg_logo_transparent.png";


//////////////////
// WEBPACK FOOTER
// ./app/views/login2/images/smartorg_logo_transparent.png
// module id = 420
// module chunks = 0